import { Component } from '@angular/core';

@Component({
  selector: 'cms-geodestinos-lab',
  template: `
    <cms-geodestino city="Vigo" initial="comer"></cms-geodestino>
  `
})
export class GeoDestinosLabComponent {}
